const EXACT_ORG_ROUTE_LABELS = new Set([
  "/api/banners/interaction",
  "/api/experiments",
  "/api/experiments/definition-variables",
  "/api/experiments/environments",
  "/api/experiments/metrics",
  "/api/experiments/products",
  "/api/experiments/prompts",
  "/api/experiments/version-history",
  "/api/get-started/completion",
  "/api/github/installations",
  "/api/github/link",
  "/api/github/repos",
  "/api/liveblocks-auth",
  "/api/reports",
  "/api/reports/pin",
  "/api/results",
  "/api/results/experiments/chart-groups",
  "/api/results/experiments/insights/group-runs",
  "/api/results/experiments/insights/groups",
  "/api/results/experiments/insights/points",
  "/api/results/experiments/results",
  "/api/results/experiments/runs",
  "/api/results/experiments/runs/count",
  "/api/results/experiments/share",
  "/api/results/experiments/variant-summaries",
  "/api/results/experiments/variant-summaries/count",
  "/api/results/pin",
  "/api/results/resources/query",
  "/api/runs",
  "/api/runs/dimension-filter-options",
  "/api/runs/experiment-filter-options",
  "/api/runs/user-filter-options",
  "/api/trace-analysis",
  "/api/trace-analysis/prompt",
  "/api/trace-analysis/suggest",
]);

const DYNAMIC_ORG_ROUTE_LABELS: ReadonlyArray<readonly [RegExp, string]> = [
  [/^\/api\/reports\/blocks\/[^/]+$/u, "/api/reports/blocks/[resultId]"],
  [/^\/api\/reports\/[^/]+\/pin$/u, "/api/reports/[reportId]/pin"],
  [/^\/api\/results\/[^/]+$/u, "/api/results/[id]"],
  [/^\/api\/trace-analysis\/[^/]+$/u, "/api/trace-analysis/[traceAnalysisId]"],
];

const BROWSER_RPC_ROUTE_LABELS = new Set([
  "/rpc/axp.v1.AxpLlmProvidersService/CreateLlmProvider",
  "/rpc/axp.v1.AxpLlmProvidersService/DeleteLlmProvider",
  "/rpc/axp.v1.AxpLlmProvidersService/ListLlmProviders",
  "/rpc/axp.v1.AxpLlmProvidersService/ReorderLlmProviders",
  "/rpc/axp.v1.AxpLlmProvidersService/TestLlmProviderConnection",
  "/rpc/axp.v1.AxpLlmProvidersService/UpdateAiGatewayConfig",
  "/rpc/axp.v1.AxpLlmProvidersService/UpdateClaudeCodeDisableExperimentalBetas",
  "/rpc/axp.v1.AxpLlmProvidersService/UpdateLlmProvider",
  "/rpc/axp.v1.AxpSecretsService/DeleteSecret",
  "/rpc/axp.v1.AxpSecretsService/ListSecrets",
  "/rpc/axp.v1.AxpSecretsService/SetSecret",
]);

/**
 * Return a bounded, identifier-free label for org-auth telemetry.
 * Unknown paths deliberately collapse to `other` instead of creating a
 * high-cardinality metric dimension.
 */
export function orgAuthRouteLabel(pathname: string): string {
  if (EXACT_ORG_ROUTE_LABELS.has(pathname) || BROWSER_RPC_ROUTE_LABELS.has(pathname)) {
    return pathname;
  }
  for (const [pattern, label] of DYNAMIC_ORG_ROUTE_LABELS) {
    if (pattern.test(pathname)) return label;
  }
  return "other";
}
